/*
Jeff wrote this
 */

$(function () {

    $("#search_box_input").keyup(function (event) {
        if (event.keyCode == 13) {
            search();
        }
    });


    $(".glossitem").hover(
   function () {
       $(this).find(".glossup").filter(':not(:animated)').animate({
           opacity: 1
       }, 500);
       $(this).find(".glossdown").filter(':not(:animated)').animate({
           opacity: 1
       }, 500);
       // This only fires if the row is not undergoing an animation when you mouseover it
   },
   function () {
       $(this).find(".glossup").animate({
           opacity: 0
       }, 250);
       $(this).find(".glossdown").animate({
           opacity: 0
       }, 250);
   });



    $('.glossarybutton').click(function (event) {
        event.preventDefault();
        search();


    });

});


$("#lucky").click(function () {

    $(".glosscolor").remove();
    $(".glossorange").remove();
    $(".selected").removeClass("selected");
    $("#searchPoem").easymark('removeHighlight');

    var randomnum = Math.round(Math.random() * $(".glossitem").size());
    $(".glossitem").eq(randomnum).addClass("selected");
    $(".glossitem").eq(randomnum).append("<div class='glossorange' style='height:" + $(".glossitem").eq(randomnum).height() + "px'><img class='glosstop' style='' src='../content/images/ui/smallup.png'><div></div></div>");
    $('html, body').animate({
        scrollTop: $(".glossitem").eq(randomnum).offset().top - 100
    }, 200);
    $(".glosstop").click(function () {
        $('html, body').animate({
            scrollTop: 50
        }, 200);
    });
    $("#search_box_input").val('');
});

function search() {
    $(".selected").removeAttr("id");
    $(".glossitem").easymark('removeHighlight');
    $(".glosscolor").remove();
    $(".glossorange").remove();
    $(".selected").removeClass("selected");
    if ($("#search_box_input").val().length) {
        $(".glossitem").easymark('highlight', $("#search_box_input").val());
    }

    $(".highlight").each(function (index) {


        $(this).closest('div').addClass("selected");

    });
    $(".selected").each(function (index) {

        $(this).attr("id", (index + 1));

        if ($(".selected").size() == 1)
        { $(this).append("<div class='glosscolor' style='height:" + $(this).height() + "px;'>&nbsp;</div>"); }
        else {
            if (index == 0)
            { $(this).append("<div class='glosscolor'  style='height:" + $(this).height() + "px;'><img class='glossdown' style='top:" + ($(this).height() / 2 + 10) + "px' src='../content/images/ui/smalldown.png'></div>"); }
            else if (index == $(".selected").size() - 1)
            { $(this).append("<div class='glosscolor' style='height:" + $(this).height() + "px;'><img class='glossup' style='top:" + ($(this).height() / 2 - 25) + "px' src='../content/images/ui/smallup.png'></div>"); }
            else {
                $(this).append("<div class='glosscolor'  style='height:" + $(this).height() + "px;'><img class='glossup' style='top:" + ($(this).height() / 2 - 25) + "px' src='../content/images/ui/smallup.png'><br><img class='glossdown' style='top:" + ($(this).height() / 2 + 10) + "px' src='../content/images/ui/smalldown.png'></div>");
            }
        }
    });
    $(".glossup").click(function () {
        var that = $(this).closest('.selected').attr('ID');

        $('html, body').animate({

            scrollTop: $("#" + (Number(that) - 1)).offset().top - 100
        }, 200);

    });

    $(".glossdown").click(function () {
        var that = $(this).closest('.selected').attr('ID');

        $('html, body').animate({

            scrollTop: $("#" + (Number(that) + 1)).offset().top - 100
        }, 200);

    });

    $('html, body').animate({

        scrollTop: $("#1").offset().top - 100
    }, 200);
}